export interface VideoItem {
  id: number;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  description: string;
  content: string;
  tags: string[];
  publishedAt: string;
  author: string;
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '流浪地球3：星际远征 - 国产科幻巨制震撼来袭',
    slug: 'the-wandering-earth-3',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20spaceship%20and%20stars%2C%20warm%20orange%20and%20gold%20tones%2C%20epic%20scale%2C%20clean%20composition%2C%20cinematic%20lighting%2C%20professional%20movie%20poster%20style%20with%20dramatic%20atmosphere&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '02:28:15',
    views: 12500000,
    rating: 9.2,
    description: '继前两部大获成功后，《流浪地球3》再度启程。人类面临全新的宇宙挑战，地球在浩瀚星空中寻找新的家园。',
    content: `<p>在《流浪地球3》中，人类文明面临着前所未有的考验。地球在经历了漫长的星际旅行后，终于接近了新的恒星系统。然而，这个看似完美的目的地却隐藏着不为人知的危险。</p><p>本片以宏大的星际视角，展现了人类在宇宙尺度下的渺小与伟大。吴京再度出演主角刘培强，带领观众走进一场关乎全人类命运的史诗冒险。</p><p>影片特效制作精良，每一帧画面都堪称视觉盛宴。从行星发动机的壮观景象到星际空间的深邃辽阔，国产科幻电影的制作水准达到了新的高度。</p><p>导演郭帆表示："这一部将是对前两部的一个全面升级，不仅是视效层面，更是在故事深度和情感表达上的突破。"</p>`,
    tags: ['科幻', '国产大片', '吴京', '郭帆', '太空'],
    publishedAt: '2026-07-20',
    author: '影视编辑部'
  },
  {
    id: 2,
    title: '长风渡 - 古装爱情传奇 白敬亭宋轶再度联手',
    slug: 'chang-feng-du',
    category: '电视剧',
    categorySlug: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20historical%20costume%20drama%20poster%2C%20warm%20golden%20lighting%2C%20ancient%20Chinese%20architecture%20background%2C%20romantic%20atmosphere%2C%20soft%20focus%2C%20period%20drama%20aesthetic%2C%20traditional%20Chinese%20elements&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '45:00',
    views: 8900000,
    rating: 8.8,
    description: '改编自同名小说，讲述商贾之女柳玉茹与纨绔子弟顾九思之间跨越阶级的动人爱情故事。',
    content: `<p>《长风渡》改编自晋江文学城作家墨书白的同名小说，由白敬亭、宋轶领衔主演。故事背景设定在架空的大荣王朝，讲述了布商之女柳玉茹与首富之子顾九思从互不顺眼到相知相爱的过程。</p><p>柳玉茹本是小门户的嫡女，因家族利益被嫁给了声名狼藉的纨绔顾九思。两人在相处中逐渐发现对方的闪光点，携手面对朝堂风云和家族变故。</p><p>该剧服装造型精美考究，场景布置恢弘大气，将中国传统文化的美学展现得淋漓尽致。白敬亭与宋轶的CP感十足，被观众誉为"年度最佳荧幕情侣"。</p>`,
    tags: ['古装', '爱情', '白敬亭', '宋轶', '小说改编'],
    publishedAt: '2026-06-15',
    author: '剧集编辑部'
  },
  {
    id: 3,
    title: '快乐再出发 第三季 - 0713男团爆笑回归',
    slug: 'happy-again-s3',
    category: '综艺',
    categorySlug: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20variety%20show%20poster%20with%20group%20of%20cheerful%20people%2C%20warm%20lighting%2C%20fun%20atmosphere%2C%20outdoor%20setting%2C%20entertainment%20show%20style%2C%20vibrant%20colors&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '90:00',
    views: 6700000,
    rating: 9.5,
    description: '0713再就业男团的欢乐旅行继续！陈楚生、苏醒、王栎鑫等老友重聚，爆笑与温情并存。',
    content: `<p>《快乐再出发》第三季再次集结0713再就业男团的核心成员——陈楚生、苏醒、王栎鑫、张远、陆虎、王铮亮。这一次，他们踏上全新的旅途，前往云南、贵州等地，体验当地的风土人情。</p><p>节目延续了前两季的真实与幽默风格，没有剧本、没有套路，只有老友之间的真诚互动。无论是即兴创作歌曲，还是在路边摊吃烧烤聊天，每一帧都充满了生活气息。</p><p>本季新增了"当地任务挑战"环节，六位成员需要完成各种有趣的任务来赚取旅行经费。从采茶到制作手工艺品，从学唱山歌到参与民俗活动，笑料不断的同时也让观众感受到了中国各地丰富多彩的文化。</p>`,
    tags: ['综艺', '0713', '旅行', '搞笑', '音乐'],
    publishedAt: '2026-07-01',
    author: '综艺编辑部'
  },
  {
    id: 4,
    title: '深海传奇 - 奥斯卡最佳动画长片获奖作品',
    slug: 'deep-sea-legend',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20animated%20film%20poster%20with%20deep%20ocean%20scenery%2C%20magical%20underwater%20world%2C%20colorful%20coral%20reefs%20and%20sea%20creatures%2C%20dreamlike%20atmosphere%2C%20anime%20art%20style%2C%20warm%20lighting%20from%20above&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '01:52:30',
    views: 9800000,
    rating: 9.0,
    description: '一部讲述深海奇幻冒险的动画电影，绚丽画面与深刻情感完美融合，斩获多项国际大奖。',
    content: `<p>《深海传奇》是一部融合了中国传统水墨画风格与现代3D动画技术的视觉盛宴。影片讲述了一个小女孩在深海中展开的奇幻冒险，她在一只神秘发光水母的引导下，穿越层层深海，探索未知世界。</p><p>影片的画面美学达到了国产动画的新高度。创作团队历时五年，自主研发了"粒子水墨"技术，将中国传统水墨的灵动与深海世界的深邃完美结合。每一帧画面都可以截图作为壁纸。</p><p>故事内核关乎成长、勇气与亲情。导演表示："深海代表了每个人内心深处的未知，而小女孩的旅程，就是每个孩子在成长中面对恐惧、发现自我的过程。"</p>`,
    tags: ['动画', '奇幻', '国产动画', '获奖', '深海'],
    publishedAt: '2026-05-10',
    author: '动漫编辑部'
  },
  {
    id: 5,
    title: '地球脉动 第四季 - 自然纪录片巅峰之作',
    slug: 'planet-earth-s4',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20poster%20with%20diverse%20wildlife%20and%20landscapes%2C%20golden%20hour%20lighting%2C%20majestic%20mountains%20and%20oceans%2C%20professional%20wildlife%20photography%20style%2C%20warm%20earth%20tones&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '01:00:00',
    views: 15600000,
    rating: 9.8,
    description: 'BBC金牌制作团队历时四年打造，用8K超高清镜头记录地球上最震撼的自然奇观与生命奇迹。',
    content: `<p>《地球脉动》第四季以史无前例的8K超高清画质，带领观众走进地球上最偏远、最壮丽的自然奇观。从南极冰原到热带雨林，从深海峡谷到高山之巅，每一集都是一场视觉盛宴。</p><p>本季聚焦气候变化对全球生态系统的影响，通过追踪多个物种的生存故事，展现了生命的韧性与脆弱。摄制组深入亚马逊雨林、撒哈拉沙漠、喜马拉雅山脉等极端环境，记录下了许多首次被镜头捕捉到的珍贵画面。</p><p>大卫·爱登堡爵士再次担任旁白，他那富有磁性的声音为这部纪录片增添了无与伦比的魅力。播出后全球评分高达9.8分，被誉为"有史以来最伟大的自然纪录片"。</p>`,
    tags: ['纪录片', '自然', 'BBC', '8K', '野生动物'],
    publishedAt: '2026-04-22',
    author: '纪录片编辑部'
  },
  {
    id: 6,
    title: '华语金曲盛典2026 - 年度音乐盛宴全记录',
    slug: 'chinese-music-awards-2026',
    category: '音乐',
    categorySlug: 'music',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20music%20awards%20ceremony%20stage%20with%20colorful%20stage%20lighting%2C%20confetti%20and%20spotlight%2C%20concert%20atmosphere%2C%20warm%20golden%20and%20amber%20lighting%2C%20celebration%20mood&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '03:15:00',
    views: 7200000,
    rating: 9.1,
    description: '华语乐坛年度最大盛事，汇聚两岸三地顶级歌手，精彩演出与颁奖典礼全程记录。',
    content: `<p>2026年华语金曲盛典在有"华语音乐圣地"之称的台北小巨蛋盛大举行。本届盛典汇聚了周杰伦、林俊杰、邓紫棋、陈奕迅等百余位华语乐坛顶级歌手和音乐人。</p><p>晚会分为"经典回响"、"新声力量"和"巅峰之夜"三大篇章。周杰伦以一曲全新编曲的《青花瓷》开场，将中国传统乐器与现代电子音乐完美融合，掀起了全场第一个高潮。</p><p>年度最佳专辑由林俊杰的《重拾快乐》摘得，年度最佳歌曲则颁给了邓紫棋的《天空之外》。最令人动容的环节是致敬已故音乐人的特别表演，全场观众起立鼓掌长达五分钟。</p>`,
    tags: ['音乐', '颁奖典礼', '华语乐坛', '演唱会', '盛典'],
    publishedAt: '2026-03-28',
    author: '音乐编辑部'
  },
  {
    id: 7,
    title: '王者荣耀S35赛季 - 巅峰对决精彩集锦',
    slug: 'honor-of-kings-s35',
    category: '游戏',
    categorySlug: 'gaming',
    thumbnail: 'https://readdy.ai/api/search-image?query=Exciting%20esports%20gaming%20competition%20poster%20with%20game%20characters%2C%20dynamic%20action%20poses%2C%20golden%20and%20red%20color%20scheme%2C%20stadium%20crowd%20atmosphere%2C%20professional%20gaming%20tournament%20style&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '25:30',
    views: 11200000,
    rating: 8.7,
    description: 'S35赛季职业联赛精彩对局解说，顶级选手的神操作与团队配合，每一场都燃到爆。',
    content: `<p>王者荣耀S35赛季职业联赛（KPL）以全新的赛制和更激烈的竞争格局回归。本集锦精选了赛季中最令人惊叹的十场对决，涵盖了从常规赛到总决赛的精华内容。</p><p>其中最受关注的是AG超玩会对阵重庆狼队的总决赛。AG超玩会在0:2落后的情况下连扳三局，完成了惊天逆转。决胜局中，一诺使用的公孙离在最后时刻以一敌三完成五杀，直接推掉水晶，这一幕被无数玩家反复回放。</p><p>本集锦还包含了专业解说对关键团战的深度分析，从阵容选择、时机把控到技能释放的每一个细节，帮助玩家提升自己的游戏理解。</p>`,
    tags: ['游戏', '王者荣耀', 'KPL', '电竞', '集锦'],
    publishedAt: '2026-07-15',
    author: '游戏编辑部'
  },
  {
    id: 8,
    title: 'NBA总决赛2026 - 史诗级七场大战全记录',
    slug: 'nba-finals-2026',
    category: '体育',
    categorySlug: 'sports',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intense%20NBA%20basketball%20finals%20game%20action%20shot%2C%20players%20dunking%2C%20stadium%20full%20of%20fans%2C%20dramatic%20sports%20photography%2C%20golden%20court%20lighting%2C%20professional%20sports%20atmosphere&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '02:10:00',
    views: 18300000,
    rating: 9.6,
    description: '2026年NBA总决赛打满七场，跌宕起伏的系列赛被誉为本世纪最精彩的决赛。',
    content: `<p>2026年NBA总决赛在洛杉矶湖人与波士顿凯尔特人之间展开，这对宿敌时隔多年再次在总决赛相遇，为球迷奉献了一场史诗级的七场大战。</p><p>系列赛从一开始就充满了戏剧性。湖人队在主场先下两城，但凯尔特人回到北岸花园后连扳两场。随后的天王山之战，湖人当家球星在最后3秒命中一记超远三分绝杀，将大比分改写为3:2。</p><p>第六场凯尔特人在主场凭借顽强的防守将系列赛拖入抢七。第七场比赛堪称经典中的经典，双方交替领先多达23次。最终，湖人以112:109险胜，捧起了队史第18座总冠军奖杯。</p>`,
    tags: ['体育', 'NBA', '篮球', '总决赛', '湖人'],
    publishedAt: '2026-06-20',
    author: '体育编辑部'
  },
  {
    id: 9,
    title: '繁花似锦 - 王家卫导演年代大剧独家上线',
    slug: 'blossoms-shanghai',
    category: '电视剧',
    categorySlug: 'drama',
    thumbnail: 'https://readdy.ai/api/search-image?query=Nostalgic%20Shanghai%20period%20drama%20poster%2C%201990s%20Chinese%20cityscape%2C%20warm%20vintage%20tones%2C%20elegant%20composition%2C%20neon%20lights%20and%20traditional%20architecture%2C%20cinematic%20style%20with%20film%20grain%20texture&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '50:00',
    views: 21000000,
    rating: 9.3,
    description: '王家卫首部电视剧作品，胡歌、马伊琍主演，讲述九十年代上海滩的商海沉浮与人生百态。',
    content: `<p>《繁花似锦》是著名导演王家卫首次执导的电视剧作品，改编自金宇澄的同名小说。故事以上世纪九十年代的上海为背景，通过主角阿宝的视角，展现了那个风云变幻年代中普通人的命运沉浮。</p><p>胡歌饰演的阿宝从一个默默无闻的小人物，凭借敏锐的商业嗅觉和不懈的努力，一步步成长为上海滩叱咤风云的商业大亨。马伊琍饰演的汪小姐则代表了那个年代独立女性的觉醒与挣扎。</p><p>王家卫独特的视觉美学在这部剧中得到了淋漓尽致的展现。每一帧画面都像是一幅精心构图的摄影作品，配合经典的九十年代金曲，将观众带回了那个充满希望与迷茫的年代。该剧一经播出便引发全民追剧热潮。</p>`,
    tags: ['电视剧', '年代剧', '王家卫', '胡歌', '上海'],
    publishedAt: '2026-07-08',
    author: '剧集编辑部'
  },
  {
    id: 10,
    title: '星际穿越2：黑洞之谜 - 诺兰科幻神作续集',
    slug: 'interstellar-2',
    category: '电影',
    categorySlug: 'movie',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20movie%20poster%20with%20black%20hole%20and%20spaceship%2C%20cosmic%20scale%2C%20warm%20orange%20accretion%20disk%2C%20deep%20space%20background%2C%20cinematic%20epic%20composition%2C%20Christopher%20Nolan%20style&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '02:45:00',
    views: 19800000,
    rating: 9.4,
    description: '诺兰时隔十年再拍科幻，探索黑洞背后的未知宇宙，视觉效果与哲学思考双重震撼。',
    content: `<p>克里斯托弗·诺兰导演的《星际穿越》续集终于来了！距离第一部上映整整十年后，诺兰再次带领观众踏上一段跨越时空的宇宙之旅。</p><p>本片的故事发生在第一部结局的数十年后。人类在库珀传回的数据帮助下，已经成功在土星附近建立了空间站。然而，一个新的谜团出现了——黑洞"卡冈图雅"正在发生不可预测的变化，似乎有人在黑洞的另一端发送信号。</p><p>影片的视觉效果再次突破了电影技术的边界。诺兰坚持实景拍摄，在冰岛、智利阿塔卡马沙漠和NASA的喷气推进实验室取景，同时结合最前沿的计算机模拟技术来呈现黑洞内部的奇幻景象。</p>`,
    tags: ['科幻', '诺兰', '太空', '黑洞', 'IMAX'],
    publishedAt: '2026-07-25',
    author: '影视编辑部'
  },
  {
    id: 11,
    title: '风味人间 第五季 - 陈晓卿美食纪录片新作',
    slug: 'once-upon-a-bite-s5',
    category: '纪录片',
    categorySlug: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mouthwatering%20food%20documentary%20poster%20with%20diverse%20Chinese%20cuisine%20dishes%2C%20steaming%20hot%20food%2C%20warm%20lighting%2C%20artistic%20food%20photography%2C%20rustic%20kitchen%20background%2C%20golden%20hour%20tones&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '55:00',
    views: 13500000,
    rating: 9.4,
    description: '跨越六大洲探访美食背后的故事，用镜头记录人与食物之间最动人的情感连接。',
    content: `<p>《风味人间》第五季由"中国美食纪录片第一人"陈晓卿执导，带领观众踏上一场横跨六大洲的美食探索之旅。本季以"味道的原点"为主题，探寻每一道美食背后最本源的风味。</p><p>从四川深山的野生菌菇到日本北海道的海胆，从意大利西西里岛的橄榄油到墨西哥瓦哈卡的巧克力，摄制组用微距镜头捕捉食物最诱人的瞬间，用故事讲述人与食物之间最深层的情感羁绊。</p><p>本季最大的亮点是采用了全新的"超微观摄影"技术，能够将食物在烹饪过程中的化学变化以视觉化的方式呈现。观众可以看到油脂在高温下跳舞、面团在发酵中呼吸，这些前所未见的画面令人叹为观止。</p>`,
    tags: ['纪录片', '美食', '陈晓卿', '风味', '人文'],
    publishedAt: '2026-05-30',
    author: '纪录片编辑部'
  },
  {
    id: 12,
    title: '剑与远征：影之传说 - 国产动画电影新标杆',
    slug: 'blade-and-shadow',
    category: '动漫',
    categorySlug: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20movie%20poster%20with%20martial%20arts%20warrior%20in%20ancient%20Chinese%20setting%2C%20dynamic%20action%20pose%2C%20ink%20wash%20painting%20style%2C%20dramatic%20lighting%2C%20traditional%20Chinese%20aesthetic&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '01:48:00',
    views: 7600000,
    rating: 8.9,
    description: '融合中国传统武侠文化与现代动画技术，讲述一段荡气回肠的江湖传奇。',
    content: `<p>《剑与远征：影之传说》是追光动画历时六年打造的武侠动画电影。影片以唐朝为背景，讲述了一位年轻剑客为寻找失落的师门绝学而踏上江湖的故事。</p><p>影片在视觉风格上大胆创新，将中国传统水墨画的意境与现代3D动画技术完美融合。打斗场面行云流水，一招一式都经过专业武术指导的精心设计，既有武侠的飘逸灵动，又不失力量感。</p><p>配音阵容同样强大，邀请了多位资深配音演员和影视演员参与。音乐由著名作曲家阿鲲操刀，以古琴、笛箫等传统乐器为主，营造出浓厚的中国古典美学氛围。</p>`,
    tags: ['动画', '武侠', '国产动画', '追光', '唐朝'],
    publishedAt: '2026-04-05',
    author: '动漫编辑部'
  }
];

export const featuredVideoIds = [9, 4, 10, 5, 8, 1];

export function getVideoBySlug(slug: string): VideoItem | undefined {
  return videos.find(v => v.slug === slug);
}

export function getVideosByCategory(categorySlug: string): VideoItem[] {
  return videos.filter(v => v.categorySlug === categorySlug);
}

export function getRelatedVideos(currentId: number, categorySlug: string, limit: number = 4): VideoItem[] {
  return videos.filter(v => v.id !== currentId && v.categorySlug === categorySlug).slice(0, limit);
}

export function getLatestVideos(limit: number = 6): VideoItem[] {
  return [...videos].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);
}